import { AbstractBlock } from '../AbstractBlock';
import { ColorSettings } from '../setting/ColorSettings';
import { ShapeSettings } from '../setting/ShapeSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
const Blockly = GlobalImport.getBlockly();
const t = block_translation;

// 		{% set color = "red" %}

function isJson(value: string): boolean {
  try {
    return typeof JSON.parse(value) === 'object';
  } catch (e) {
    return false;
  }
}

export class UpdateAttributeBlock extends AbstractBlock {
  VAR_NAME = 'VAR_NAME';
  VALUE = 'VALUE';

  constructor() {
    super('logic_update_attribute', '属性を更新');
  }

  override defineBlock(block: BlockType): void {
    ColorSettings.setLogicColor(block);
    ShapeSettings.setElementShape(block);

    // フィールド
    const var_name = new Blockly.FieldTextInput('id');

    // 属性値の入力フィールド
    block
      .appendDummyInput()
      .appendField(t.to('ブロック', 'update_att_1'))
      .appendField(var_name, this.VAR_NAME)
      .appendField(t.to('を', 'update_att_2'))
      ShapeSettings.addAttributeInput(block);
    block
      .appendDummyInput()
      .appendField(t.to('に変更', 'update_att_3'));
  }

  override codeGenerateCore(block: BlockType): string {
    const varName = CodeSetting.getFieldValue(block, this.VAR_NAME);
    const attribute = CodeSetting.getSubAttributeCode(block);

    const str = CodeSetting.getUpdateElementCode(varName, attribute);


    return str;
  }
}
